export function buildLookbackPeriodSubLabel(months: number): string | undefined {
    if (months == 0) {
        return undefined;
    }
    if (months == 1) {
        return "(1 month ago)";
    }

    return `(${months} months ago)`;
}